export default {
    doctor: 'Doctor',
    patient: 'Patient',
    urology:'Urology',
    donation_clinic:'Donation Clinic',
    legal:'Legal',
    genetics:'Genetics',
    nourish:'Nourish',
    nurse:'Nurse',
    midwife:'Midwife',
    social:'',
    normal:'',
    roles: 'Roles',
    role: 'Role',
    cashier:	"Cashier",
    psychological_advisor:	"psychological_advisor",
    glands:	"Glands",
    infertility:	"Infertility",
    gynecology:	"Gynecology",
    obstetric:	"Obstetric",
    radiology:	"Radiology",
    referral_doctor:	"Referral_doctor",
    secretary:	"Secretary",
}